import { DigitalTwinLicence } from "@iventis/domain-model/model/digitalTwinLicence";
import { DigitalTwinInstanceStatus } from "@iventis/domain-model/model/digitalTwinInstanceStatus";
import { DigitalTwinStatus } from "./digitial-twin-types";

export function getDigitalTwinStatus(digitalTwinLicence: DigitalTwinLicence, userId: string): DigitalTwinStatus {
    if (digitalTwinLicence == null) {
        return "occupied";
    }
    // If the user has been assigned a licence but there is no instance yet then its searching for an instance
    if (digitalTwinLicence.userId != null && digitalTwinLicence.userId === userId && digitalTwinLicence.instance == null) {
        return "searching";
    }

    // If the user's licence has an instance but its starting then return starting
    if (digitalTwinLicence.instance != null && digitalTwinLicence.userId === userId && digitalTwinLicence.instance.status === DigitalTwinInstanceStatus.Starting) {
        return "starting";
    }

    // If the user's licence has an instance and its available then return available
    if (digitalTwinLicence.instance != null && digitalTwinLicence.userId === userId && digitalTwinLicence.instance.status === DigitalTwinInstanceStatus.Available) {
        return "available";
    }

    // If the user's licence has an instance and its occupied then return available as its themselves using it
    if (digitalTwinLicence.instance != null && digitalTwinLicence.userId === userId && digitalTwinLicence.instance.status === DigitalTwinInstanceStatus.Occupied) {
        return "available";
    }
    return "error";
}
